<template>
  <div class="travelDetails" id="printMe" ref="print">
    <Header></Header>
    <Nav></Nav>
    <div class="travelDetailsTitle">
      <h3>{{articleData.title}}</h3>
      <div class="travelDetailsTitle_text">
        <p>{{articleData.writetime}} 作者：{{articleData.authorname}}</p>
        <div class="article_btn">
          <span @click="doPrintVue()"><i class="fa fa-print"></i>打印</span>
          <span @click="isshare = !isshare"><i class="fa fa-share-alt"></i>分享</span>
          <div class="share_btn" v-if="isshare" data-tag="share_1">
            <a href="#" class="icon-wechat social-share-icon" @click="shareF()"></a>
            <share :config="config"></share>
          </div>
          <!-- <share class="share_btn" :config="config" v-show="isshare"></share> -->
        </div>
      </div>
      <img src="../assets/static/images/footer-split.png" alt="">
    </div>
    <div class="article_content" v-html="articleData.content">

    </div>
    <Footer></Footer>
    <div class="qrcode_dialog" v-show="isqrcode_dialog">
      <div class="bd_weixin_popup_head"><span>分享到微信朋友圈</span><a href="#" onclick="return false;" class="bd_weixin_popup_close"
          @click="isqrcode_dialog = false">×</a></div>
      <div class="QRCode_b">
        <div id="QRCode" ref="qrCodeDiv"></div>
      </div>
      <p>打开微信，点击底部的“发现”，</p>
      <p>使用“扫一扫”即可将网页分享至朋友圈。</p>
    </div>
  </div>
</template>

<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  import 'vue-social-share/dist/client.css';
  import QRCode from 'qrcodejs2';
  export default {
    data() {
      return {
        articleData: [],
        id: '',
        isshare: false,
        config: {
          url: window.location.href,
          source: "1212",
          title: '标题',
          description: '描述',
          sites: ['qzone', 'weibo'],
        },
        isqrcode_dialog: false
      }
    },
    components: {
      Header,
      Footer,
      Nav,
      QRCode
    },
    computed: {

    },
    methods: {
      getDetails() {
        this.axios.post('api/c_article/getDetail.do', this.qs({
          id: this.id
        })).then(res => {
          if (res.status == 200) {
            res.data.data.writetime = this.$getMyDate(res.data.data.writetime)
            this.articleData = res.data.data
            this.config.title = this.articleData.title
            this.config.source = this.articleData.subtitle
            this.config.description = this.articleData.subtitle
            
            // setTimeout(function(){
            //   var video = document.querySelector('video');
            //   console.log(video)
            //   video.preload='metadata'
            // },500)
             
            // video.setAttribute('preload','metadata');
            // console.log(11)
            
          }
        })
      },
      //打印
      doPrintVue() {
        this.$print(this.$refs.print)
      },
      //微信分享二维码
      shareF(type) {
        var msg = document.getElementById("QRCode");
        msg.innerHTML = ''
        // 将获取到的数据（val）画到msg（canvas）上
        console.log(this.config.url);
        var qrcode = new QRCode(this.$refs.qrCodeDiv, {
          text: this.config.url,
          width: 205,
          height: 205,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
        })
        this.isqrcode_dialog = true
      }
    },
    mounted() {
      this.id = this.$route.query.id
      this.getDetails()
      this.config.url = window.location.href
    }
  }
</script>

<style>
  .article_btn {
    position: relative;
  }

  .share_btn {
    position: absolute;
    right: 0;
    top: 52px;
    width: 50px;
  }

  .share_btn a {
    background-repeat: no-repeat;
    cursor: pointer;
    margin: 6px 6px 6px 0;
    text-indent: -100em;
    color: #3a8ceb;
    line-height: 32px;
    height: 50px !important;
    width: 50px !important;
    display: inline-block;
    border-radius: 0 !important;
  }

  .share_btn a.icon-wechat {
    background-color: #179417;
    background-image: url('../assets/static/images/i-weixin.png') !important;
    background-position: center center;
    margin-bottom: 0px;
  }

  .share_btn a.icon-weibo {
    background-color: #d84545;
    background-image: url('../assets/static/images/i-weibo.png') !important;
    background-position: center center;
  }

  .share_btn a.icon-qzone {
    background-color: #caa126;
    background-image: url('../assets/static/images/i-qzone.png') !important;
    background-position: center center;
  }

  .share_btn a.social-share-icon:hover {
    color: #333;
    opacity: .8;
    background-position: center center !important;
    background-repeat: no-repeat;
  }

  .social-share .icon-qzone:hover {
    background-color: #FDBE3D !important;
  }

  /* .social-share .icon-wechat .wechat-qrcode{position: fixed;} */
  .social-share .icon-qzone:before,
  .social-share .icon-weibo:before,
  .social-share .icon-wechat:before {
    content: "" !important;
  }

  .social-share .icon-qzone:hover .wechat-qrcode {
    display: none;
  }

  .qrcode_dialog {
    position: fixed;
    width: 250px;
    left: calc((100% - 250px) / 2);
    top: 250px;
    background: #fff;
    padding-top: 15px;
    border: solid 1px #d8d8d8;
    padding-bottom: 30px;
  }

  #QRCode img {
    width: 205px !important;
    height: 205px !important;
    display: block;
    margin: 15px auto;
  }

  .bd_weixin_popup_head {
    font-size: 12px;
    font-weight: bold;
    text-align: left;
    line-height: 16px;
    height: 16px;
    position: relative;
    color: #000;
    padding: 0 15px;
  }

  .bd_weixin_popup_head {
    font-size: 16px;
  }

  .bd_weixin_popup_head .bd_weixin_popup_close {
    width: 16px;
    height: 16px;
    position: absolute;
    right: 15px;
    top: 0;
    color: #999;
    text-decoration: none;
    font-size: 16px;
  }

  .qrcode_dialog p {
    font-size: 12px;
    text-align: left;
    line-height: 22px;
    color: #666;
    margin: 0;
    padding-left: 20px;
  }

  .travelDetailsTitle img {
    width: 100%;
  }
</style>
